module.exports = __webpack_public_path__ + "c012d8edaab8bae1bb59ddf6f285e01d.svg";